export const convertDateFromInput = (date) => {
  if (!date) return null

  const parsedDate = new Date(date)

  if (isNaN(parsedDate.getTime())) {
    return null
  }

  const localDate = new Date(parsedDate.getTime() - parsedDate.getTimezoneOffset() * 60000)

  return localDate.toISOString().split('T')[0]
}

export const formatDateToApi = (date) => {
  return convertDateFromInput(date)
}

export function getFormattedDatetime(datetime) {
  if (datetime) {
    const date = new Date(datetime).toLocaleDateString()
    const time = new Date(datetime).toLocaleTimeString()
    return date + ' ' + time
  } else {
    return '-'
  }
}
